import React from "react";
import CardAlert from "../../atoms/card-alert/CardAlert";
import useElementSize from "../../../hooks/useElementSize";

// Styles //
import "./vacancyNoFound.scss";

const VacancyNoFound = () => {
    const headerSize = useElementSize(".m-header");

    return (
        <div
            className="m-vacancyNoFound"
            style={{ marginTop: `${headerSize.height}px` }}
        >
            <CardAlert
                iconUrl="https://images.ctfassets.net/203frbsx1z3n/3Etfwe1Orssxm0rYcvPDFF/5842b979c725cbd85e4ed90ce1f30609/Grupo_19929.png?h=250"
                title={"¡UPS! Esta vacante ya no se encuentra activa."}
                btnText={"Ir a vacantes"}
                href={"/servicio-de-empleo/personas/vacantes-en-antioquia/"}
            >
                <p>
                    Conoce más ofertas laborales disponibles en nuestra página web.
                </p>
            </CardAlert>
        </div>
    );
};

export default VacancyNoFound;
